export class AppointmentId {
  public readonly _tag = 'AppointmentId';

  constructor(public readonly value: number) {}

  static of = (value: number): AppointmentId => new AppointmentId(value);
}
